import request from '@/utils/request'

export const login = (data) => {
  return request({
    url: '/sys/oauth/token',
    method: 'POST',
    params: {
      grant_type: 'password',
      scope: 'server',
      ...data
    },
    auth: {
      username: 'ctt',
      password: 'ctt'
    }
  })
}

/**
 * 获取用户信息
 */
export const getUserInfo = () => {
  return request({
    url: '/sys/v1/user/current'
  })
}

/**
 * 获取用户信息
 */
export const getUser = () => {
  return request({
    url: '/sys/v1/user/getClinicManagerInfo'
  })
}

/**
 * 图片上传
 */
export const uploadImage = (data) => {
  return request({
    method: 'POST',
    url: '/sys/v1/file/uploadImage',
    data
  })
}

/**
 * 修改密码
 * @param {*} data
 * @returns
 */
export const changePassword = (data) => {
  return request({
    url: '/sys/v1/user/password',
    method: 'PUT',
    data
  })
}

/**
 * 上传文件
 * @param {*} data
 * @returns
 */
export const uploadFile = (data) => {
  return request({
    url: '/sys/v1/file/uploadFile',
    method: 'POST',
    data
  })
}

/**
 * 获取日志信息
 * @param {*} params
 */
export const getLogPage = (params) => {
  return request({
    url: '/sys/v1/log/page-plus',
    params
  })
}

/**
 * 根据id获取日志详情
 * @param {*} id
 * @returns
 */
export const getLogDetail = (id) => {
  return request({
    url: `/sys/v1/log/${id}`
  })
}

/**
 * 查询加密狗日志详情
 * @param {*} data
 * @returns
 */
export const getDongleLogInfo = (id) => {
  return request({
    url: `/sys/v1/interfaceLog/${id}`
  })
}

/**
 * 查询加密狗日志详情
 * @param {*} data
 * @returns
 */
export const getDongleLogPage = (data) => {
  return request({
    url: '/sys/v1/interfaceLog/findDongleLogPage',
    params: data
  })
}

/**
 * 查询平台授权app应用日志操作记录分页(平台授权日志)
 * @param {*} data
 * @returns
 */
export const getAuthPlatFormAppLogPage = (data) => {
  return request({
    url: '/sys/v1/interfaceLog/findAuthPlatFormAppLogPage',
    params: data
  })
}

/**
 * 切换后台用户最后一次选择的租户和门诊
 * @param {*} data
 * @returns
 */
export const switchUserInfo = (data) => {
  return request({
    method: 'POST',
    url: '/sys/v1/user/switchUserInfo',
    data
  })
}

/**
 * 获取阿里云数据
 * @returns
 */
export const getSts = () => {
  return request({
    url: '/sys/v1/aliyun/oss/getStsToken'
  })
}

/**
 * 生成临时二维码(300s失效)【Web使用】
 * @param {*} path
 * @returns
 */
export const getWebQrCode = (path = 'n0suzj7xj387capww8m2cey8mhijndl5s0uvthuvdm0') => {
  return request({
    url: `/yia/v1/wx/scanCodeAuth/${path}/getWebQrCode`
  })
}

/**
 * 得到当前公众号扫码用户信息【Web使用】
 * @param {*} path
 * @returns
 */
export const getWebScanUser = (path = 'n0suzj7xj387capww8m2cey8mhijndl5s0uvthuvdm0') => {
  return request({
    url: `/yia/v1/wx/scanCodeAuth/${path}/getWebScanUser`
  })
}

/**
 * 用户信息分页列表
 * @param {*} path
 * @returns
 */
export const getWebsiteUserPage = (data) => {
  return request({
    method: 'POST',
    url: '/sys/v1/manager/websiteUser/list',
    data
  })
}

/**
 * applink开通数、在线数、当日请求数相关统计
 * @returns
 */
export const getApplinkStatistics = () => {
  return request({
    url: '/bus/v1/applink/statistics',
    method: 'POST'
  })
}

/**
 * applink在线数门店
 * @returns
 */
export const getApplinkOnlineClinics = () => {
  return request({
    url: '/bus/v1/applink/onlineClinics',
    method: 'POST'
  })
}

/**
 * applink在线数门店
 * @returns
 */
export const getApplinkAllClinics = () => {
  return request({
    url: '/bus/v1/applink/AllClinicsStatus',
    method: 'POST'
  })
}

/**
 * applink操作日志分页
 * @returns
 */
export const getApplinkLogList = (data) => {
  return request({
    url: '/bus/v1/applink/list',
    method: 'POST',
    data
  })
}
